var map = {
	"./1.jpg": 1335,
	"./10.jpg": 1336,
	"./11.jpg": 1337,
	"./12.jpg": 1338,
	"./13.jpg": 1339,
	"./14.jpg": 1340,
	"./15.jpg": 1341,
	"./16.jpg": 1342,
	"./17.jpg": 1343,
	"./18.jpg": 1344,
	"./19.jpg": 1345,
	"./2.jpg": 1346,
	"./20.jpg": 1347,
	"./21.jpg": 1348,
	"./22.jpg": 1349,
	"./23.jpg": 1350,
	"./24.jpg": 1351,
	"./25.jpg": 1352,
	"./26.jpg": 1353,
	"./27.jpg": 1354,
	"./28.jpg": 1355,
	"./29.jpg": 1356,
	"./3.jpg": 1357,
	"./30.jpg": 1358,
	"./31.jpg": 1359,
	"./32.jpg": 1360,
	"./33.jpg": 1361,
	"./34.jpg": 1362,
	"./4.jpg": 1363,
	"./5.jpg": 1364,
	"./6.jpg": 1365,
	"./7.jpg": 1366,
	"./8.jpg": 1367,
	"./9.jpg": 1368,
	"./beijing.jpg": 640,
	"./desktop.jpg": 641,
	"./germany.jpg": 642,
	"./kyoto.jpg": 643,
	"./london.jpg": 645,
	"./mobile.jpg": 1376,
	"./paris.jpg": 646,
	"./singapore.jpg": 647,
	"./taiwan.jpg": 648,
	"./tokyo.jpg": 649,
	"./zurich.jpg": 650
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2071;



//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew ^\.\/.*\.jpg$
// module id = 2071
// module chunks = 47